import { NumericFormat } from 'react-number-format';

const FormattedNumber = ({ value, decimalScale }) => (
  <NumericFormat
    decimalScale={decimalScale}
    displayType='text'
    fixedDecimalScale={decimalScale !== undefined}
    thousandSeparator
    value={value}
  />
);

export default FormattedNumber;
